import Hub from "../Svg/Hub";
import Room from "../Svg/Room";
import TwinHub from "../Svg/TwinHub";
import MovieHub from "../Svg/MovieHub";

export default function ReservationCardCategoryIcon(
  {RoomCategoryName, className = "size-fluid-4"}: {RoomCategoryName: string, className?: string}
) {

  return (
    <>
      {RoomCategoryName === "Hub" && <Hub className={`${className}`} />}
      {RoomCategoryName === "Twin Hub" && <TwinHub className={`${className}`} />}
      {RoomCategoryName === "Room" && (
        <>
          <Room className={`${className}`} /> <Room className={`${className}`} />
        </>
      )}
      {RoomCategoryName === "Movie Hub" && <MovieHub className={`${className}`} />}
    </>
  );
}
